import { PortalUrls } from '@servicetitan/cp-ui';
import { IconNameType } from '@servicetitan/design-system';
import { inject, injectable } from '@servicetitan/react-ioc';
import { computed, makeObservable } from 'mobx';
import { PortalAuthStore } from '../../auth/stores/portal-auth.store';
import { AppSettingsStore } from './app-settings.store';

interface NavigationLink {
    title: string;
    path: string;
    exact?: boolean;
    icon?: IconNameType;
}

@injectable()
export class NavigationStore {
    constructor(
        @inject(PortalAuthStore) private authStore: PortalAuthStore,
        @inject(AppSettingsStore) private appSettingsStore: AppSettingsStore
    ) {
        makeObservable(this);
    }

    @computed get navigationLinks(): NavigationLink[] {
        if (!this.authStore.authorized) {
            return [];
        }

        const out: NavigationLink[] = [
            {
                title: 'My Tasks',
                path: '/',
                exact: true,
                icon: 'home',
            },
        ];

        out.push({
            title: 'Jobs',
            path: PortalUrls.jobs.root,
            icon: 'job',
        });

        out.push({
            title: 'Invoices',
            path: PortalUrls.invoices.root,
            icon: 'st_invoice',
        });

        if (this.appSettingsStore.proposalsEstimatesEnabled) {
            out.push({
                title: 'Proposals',
                path: PortalUrls.proposals.root,
                icon: 'proposal',
            });
        }

        const { user } = this.authStore.portalStore;

        const pickMembership = user?.pickMembership;

        if (this.appSettingsStore.membershipSettings.enabled && pickMembership) {
            out.push({
                title: pickMembership('Memberships', 'Contracts'),
                path: pickMembership(
                    PortalUrls.memberships.rootMembership,
                    PortalUrls.memberships.rootContracts
                ),
                icon: 'card_membership',
            });
        }

        if (this.appSettingsStore.serviceAgreementsEnabled) {
            out.push({
                title: 'Service Agreements',
                path: PortalUrls.serviceAgreements.root,
                icon: 'st_service_agreements',
            });
        }

        return out;
    }
}
